import React from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import SmartDialog from "../components/SmartDialog";
import Select from "react-select";
import {Button} from "reactstrap";

export class MultiSelectionDialog extends React.Component {

    static  propTypes = {
        message: PropTypes.string,
        title: PropTypes.string,
        saveBtnText: PropTypes.string
    };

    static defaultProps = {
        message: "Please select options",
        title: "Select Option",
        saveBtnText: "Save Selection"
    };

    constructor(props) {
        super(props);
        this.state = MultiSelectionDialog.getInitialState();
        this.onApply = this.onApply.bind(this);
        this.onCancel = this.onCancel.bind(this);
    }

    static getInitialState() {

        return {
            message: null,
            title: null,
            options: null,
            values: null,
            callback: null,
            saveBtnText: null,
            selectedValues: null
        };
    }

    /**
     * Show multi selection dialog
     * @param options Options to be displayed
     * @param values  Default selected values
     * @param callback Callback function
     * @param title Title of dialog
     * @param message Info message
     * @param saveBtnText Save button text
     */
    show(options,
         values,
         callback,
         title = null,
         message = null,
         saveBtnText = null) {

        this.setState({
            options,
            values,
            selectedValues: _.cloneDeep(values),
            callback,
            title,
            message,
            saveBtnText
        }, () => this._dlg.show());

    }

    onApply() {

        if (_.isFunction(this.state.callback)) {

            //
            this.state.callback(this.state.selectedValues);

            //
            this._dlg.hide();
        }

    }

    onCancel() {
        this._dlg.hide();
    }

    render() {

        return <SmartDialog title={this.state.title || this.props.title} ref={r => this._dlg = r}>

            <p>{this.state.message || this.props.message}</p>

            <hr/>

            <Select ref={r => this._select = r}
                    isMulti
                    defaultValue={this.state.values}
                    onChange={values => {

                        this.setState({
                            selectedValues: values
                        });

                    }}
                    options={this.state.options}/>

            <hr/>

            <Button color={"green"} onClick={this.onApply} block><i className="fa fa-check"/> {this.state.saveBtnText || this.props.saveBtnText}</Button>

        </SmartDialog>
    }

}


// WEBPACK FOOTER //
// ./src/common/MultiSelectionDialog.js